import { isNumber } from "./metrics";

export const convertUnit = (unit, value) => {
  switch (unit?.toLowerCase()) {
    case "degrees":
    case "degrees/second":
      return value; // Assuming value is already in degrees or degrees/sec
    case "g":
    case "gs":
      return value / 9806.65; // Convert mm/s^2 to g (1 g ≈ 9806.65 mm/s^2)
    case "inches":
      return value / 25.4; // Convert mm to inches (1 inch = 25.4 mm)
    case "m/s/s":
      return value / 1000; // Convert mm/s^2 to m/s^2
    case "mph":
      return value * 0.002237; // Convert mm/s to mph (1 mm/s = 0.002237 mph)
    case "ms":
      return value * 1000;
    case "percent":
      return value * 100; // Convert ratio to percentage
    case "ratio":
      return value; // Assuming ratio is unitless
    case "seconds":
      return value;
    default:
      return value; // Return the original value if no conversion is needed
  }
};

export function formatUnit(unit, value, options) {
  if (!isNumber(value)) return "n/a";

  const { convert = true, dp = null, showSymbol = true } = options ?? {};
  const parsedUnit = (unit ?? "").toLowerCase();

  const converted = value;

  const autoRound = (v, fallback) => {
    if (v >= 100) return v.toFixed(0);
    return v.toFixed(fallback);
  };

  // If dp is explicitly provided, use it for all units
  const getDecimalPlaces = (fallback) => {
    if (dp !== null && dp !== undefined) return dp;
    return fallback;
  };

  switch (parsedUnit) {
    case "degrees":
      return `${converted.toFixed(getDecimalPlaces(0))}${
        showSymbol ? "°" : ""
      }`;

    case "degrees/second":
      return `${converted.toFixed(getDecimalPlaces(0))}${
        showSymbol ? " d/s" : ""
      }`;

    case "g":
    case "gs":
      return `${autoRound(converted, getDecimalPlaces(1))}${
        showSymbol ? " g" : ""
      }`;

    case "inches": {
      const formatted = autoRound(converted, getDecimalPlaces(1));
      return `${formatted}${showSymbol ? '"' : ""}`;
    }
    case "m/s/s":
      return `${autoRound(converted, getDecimalPlaces(2))}${
        showSymbol ? " m/s²" : ""
      }`;

    case "mm":
      return `${autoRound(converted, getDecimalPlaces(0))}${
        showSymbol ? " mm" : ""
      }`;

    case "mph":
      return `${autoRound(converted, getDecimalPlaces(1))}${
        showSymbol ? " mph" : ""
      }`;

    case "ms":
      return `${converted.toFixed(getDecimalPlaces(0))}${
        showSymbol ? " ms" : ""
      }`;

    case "order":
      return converted.toFixed(getDecimalPlaces(0));

    case "percent":
      return `${autoRound(converted, getDecimalPlaces(0))}${
        showSymbol ? "%" : ""
      }`;

    case "ratio":
    case "spdhgt":
      return `${autoRound(converted, getDecimalPlaces(2))}${
        showSymbol ? " ratio" : ""
      }`;

    case "seconds":
      return `${converted.toFixed(getDecimalPlaces(2))}${
        showSymbol ? " sec" : ""
      }`;

    default:
      return autoRound(converted, dp ?? 0);
  }
}
